const yesItems = [
  "You have a trip coming up in 1–8 weeks",
  "Your passport expired or is expiring soon",
  "Your destination requires 6 months validity beyond your return date",
  "You've already tried mailing it yourself and it's not moving fast enough",
  "You live far from a passport agency — Tampa, Charlotte, Nashville, Louisville, Sacramento, Kansas City, Bozeman",
  "You don't want to take a day off work to drive to a passport agency",
  "You want expert document review so your application doesn't get rejected",
];

const noItems = [
  "Your trip is more than 8 weeks away with no urgency — standard government processing is fine and free beyond the $60 expedite fee",
  "You don't qualify for renewal (DS-82) — you may need a new passport instead",
];

export default function WhoThisIsForSection() {
  return (
    <section className="py-16 md:py-20 bg-[#f7faf9]">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-12">
          Is Fast Passport Renewal Right for You?
        </h2>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1 bg-white border border-green-200 rounded-lg p-6 md:p-8">
            <h3 className="text-lg font-bold text-[#1B4D3E] mb-5 flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-[#1B4D3E] flex items-center justify-center">
                <i className="ri-check-line text-white"></i>
              </span>
              YES — Fast Renewal is Right For You
            </h3>
            <ul className="space-y-3">
              {yesItems.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-700">
                  <span className="flex-shrink-0 text-green-600 mt-0.5">
                    <i className="ri-checkbox-circle-fill"></i>
                  </span>
                  <span className="text-sm md:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 bg-white border border-red-200 rounded-lg p-6 md:p-8">
            <h3 className="text-lg font-bold text-red-700 mb-5 flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                <i className="ri-close-line text-red-600"></i>
              </span>
              NOT the Right Fit
            </h3>
            <ul className="space-y-3">
              {noItems.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-700">
                  <span className="flex-shrink-0 text-red-400 mt-0.5">
                    <i className="ri-close-circle-fill"></i>
                  </span>
                  <span className="text-sm md:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}